(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["al-imageblock"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
AL.iblock.init();

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-pl-bundles"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function ()
{
AL.albunles.init();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-product-landing-main"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
AL.pcheader.init();

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["al-videoimage-slider"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.videoimage.init();
 console.log("1");

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    


$(document).ready(function ()
{
AL.cart.init();
AL.giftwrap.init();

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-bundle-book"]) return;
  try {
    


$(function () {
AL.collection.init();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    


$(function () {
AL.collection.init();
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-image"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function ()
{
AL.hero.init();
})




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-mob"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function ()
{
AL.heromobile.init();
})




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function ()
{
AL.hero.init();
})




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    



$(document).ready(function ()
{
AL.hero.init();
})




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-feedback"] && !Shopify.designMode) return;
  try {
    


    $(document).ready(function ()
    {
    AL.feedback.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-blank"]) return;
  try {
    


$(document).ready(function ()
{
AL.product.init();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-book-bundles"]) return;
  try {
    


    $(document).ready(function ()
    {
    AL.product.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-builder-newset-for-bundles"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.product.init();
    AL.plcartv2.init();
    AL.popups.init();

    AL.iblockv2.init();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-builder-newset-other"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.product.init();
    AL.plcartv2.init();
    AL.popups.init();

    AL.iblockv2.init();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-builder-newset"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.product.init();
    AL.plcartv2.init();
    AL.popups.init();

    AL.iblockv2.init();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bundle-builder"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.product.init();
    AL.plcartv2.init();
    AL.popups.init();

    AL.iblockv2.init();

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-key-chain"]) return;
  try {
    


    $(document).ready(function ()
    {
        AL.product.init();
        AL.productchain.init();
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-landing-01"] && !Shopify.designMode) return;
  try {
    

$(window).load(function() {

if( $('.insagram-wrap').data('tag') == "")
{
var feed = new Instafeed({
get: 'user',
userId: 7366433225,
accessToken: '7366433225.1677ed0.3d19c244ecb54414b74e73db7800daa9',
resolution: 'low_resolution',
after: function () {
AL.common.instaSlider();
},
template: '<div class="insta-feed"><a target="blank" href="{{link}}"><img src="{{image}}" /></a></div>'
});
}

else
{
var tags = $('.insagram-wrap').data('tag');
var feed = new Instafeed({
get: 'user',
userId: 7366433225,
accessToken: '7366433225.1677ed0.3d19c244ecb54414b74e73db7800daa9',
resolution: 'low_resolution',
after: function () {
AL.common.instaSlider();
},
filter: function(image) {
return image.tags.indexOf(tags) >= 0;
},
template: '<div class="insta-feed"><a target="blank" href="{{link}}"><img src="{{image}}" /></a> </div>'
});
}


feed.run();

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    


$(document).ready(function ()
{
AL.product.init();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product25"]) return;
  try {
    


$(document).ready(function ()
{
AL.product.init();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set2-bundles"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function ()
{
AL.albunles.init();
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set2-imageblock"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
AL.iblock.init();

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set2-instagram-feed"] && !Shopify.designMode) return;
  try {
    

$(window).load(function() {

if( $('.insagram-wrap').data('tag') == "")
{
var feed = new Instafeed({
get: 'user',
userId: 7366433225,
accessToken: '7366433225.1677ed0.3d19c244ecb54414b74e73db7800daa9',
resolution: 'low_resolution',
after: function () {
AL.common.instaSlider();
},
template: '<div class="insta-feed"><a target="blank" href="{{link}}"><img src="{{image}}" /></a></div>'
});
}

else
{
var tags = $('.insagram-wrap').data('tag');
var feed = new Instafeed({
get: 'user',
userId: 7366433225,
accessToken: '7366433225.1677ed0.3d19c244ecb54414b74e73db7800daa9',
resolution: 'low_resolution',
after: function () {
AL.common.instaSlider();
},
filter: function(image) {
return image.tags.indexOf(tags) >= 0;
},
template: '<div class="insta-feed"><a target="blank" href="{{link}}"><img src="{{image}}" /></a> </div>'
});
}


feed.run();

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set2-product-landing-main"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
AL.pcheader.init();

})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["set2-videoimage-slider"] && !Shopify.designMode) return;
  try {
    


$(document).ready(function ()
{
    AL.videoimage.init();
 console.log("1");

})



  } catch(e) { console.error(e); }
})();
})();
